import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Iconify from 'src/components/iconify'
import { LoadingScreen } from 'src/components/loading-screen'

interface MetricCardProps {
  title: string
  value: string | number
  icon: string
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info'
  subtitle?: string
  isLoading?: boolean
}

export default function MetricCard({
  title,
  value,
  icon,
  color = 'primary',
  subtitle,
  isLoading,
}: MetricCardProps) {
  return (
    <Paper
      sx={{
        p: 2.25,
        borderRadius: 2,
        bgcolor: 'background.paper',
        border: (theme) => `1px solid ${theme.palette[color].lighter}`,
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: (theme) => theme.palette[color].light,
          boxShadow: (theme) => `0 6px 16px ${theme.palette[color].main}1a`,
        },
      }}
    >
      {isLoading ? (
        <LoadingScreen sx={{ borderRadius: 2 }} />
      ) : (
        <Stack direction='row' alignItems='center' spacing={2}>
          <Box
            sx={{
              width: 48,
              height: 48,
              minWidth: 48,
              borderRadius: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: (theme) => theme.palette[color].lighter,
              color: (theme) => theme.palette[color].dark,
            }}
          >
            <Iconify icon={icon} width={26} />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant='caption'
              color='text.secondary'
              sx={{ fontWeight: 600, letterSpacing: 0.3, textTransform: 'uppercase', fontSize: 11 }}
            >
              {title}
            </Typography>
            <Typography
              variant='h5'
              fontWeight={700}
              color={`${color}.darker`}
              sx={{ lineHeight: 1.2, mt: 0.25 }}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography
                variant='caption'
                color='text.secondary'
                sx={{ display: 'block', mt: 0.25, fontSize: 11 }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
      )}
    </Paper>
  )
}
